import type { DayPickerDefaultProps } from "react-day-picker";
import { getDateFNSLocale } from "@repo/utils";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { useBooking } from "~/hooks/use-booking";
import { useMediaQuery } from "~/hooks/use-media-query";
import { useGeneralStore } from "~/stores/use-general-store";
import { Calendar } from "../ui/calendar";

interface BookingDatePickerProps extends DayPickerDefaultProps {
  onSelect: (date: Date) => void;
}

export function BookingDatePicker({
  month,
  disableNavigation,
  onSelect,
  selected,
  showOutsideDays,
}: BookingDatePickerProps) {
  const { bookings } = useBooking();

  const { setLayoutCalendarOpen } = useGeneralStore();

  const pathname = window.location.pathname;

  const { i18n } = useTranslation();

  const locale = i18n.language;

  const isMedium = useMediaQuery(1024);

  const bookedDays = bookings.map((booking) => booking.startTime);

  const navigate = useNavigate();

  const handleDayClick = (day: Date) => {
    if (isMedium) {
      setLayoutCalendarOpen(false);
    }
    onSelect(day);
    if (!pathname.includes("booking")) {
      void navigate({ to: "/bookings" });
    }
  };

  return (
    <Calendar
      showOutsideDays={showOutsideDays}
      disableNavigation={disableNavigation}
      locale={getDateFNSLocale(locale)}
      mode="single"
      modifiers={{
        hasEvent: bookedDays,
      }}
      modifiersClassNames={{
        hasEvent: "has-event",
      }}
      month={month}
      onDayClick={handleDayClick}
      selected={selected}
    />
  );
}
